import { useSystemStore } from "components/PageHeader/systemStore";
import Image from "next/image";
import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const IconBell: React.FC<Props> = ({
  size = 14,
  color = "#FFFFFF",
  className = "fill-purple80_to_white",
}) => {
  const theme = useSystemStore((state) => state.theme);

  return (
    <Image 
      alt="notif"
      src={"/images/notif.svg"}
      width={24}
      height={24}
      className={theme === "dark" ? "invert brightness-0" : ""}
    />
  );
};
